import { render } from "./UserTraining.vue?vue&type=template&id=4a26cce2&scoped=true"
import script from "./UserTraining.vue?vue&type=script&lang=js"
export * from "./UserTraining.vue?vue&type=script&lang=js"

import "./UserTraining.vue?vue&type=style&index=0&id=4a26cce2&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a26cce2"]])

export default __exports__